import { render, staticRenderFns } from "./NumberInputType.vue?vue&type=template&id=22767108&scoped=true"
import script from "./NumberInputType.vue?vue&type=script&lang=js"
export * from "./NumberInputType.vue?vue&type=script&lang=js"
import style0 from "./NumberInputType.vue?vue&type=style&index=0&id=22767108&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22767108",
  null
  
)

export default component.exports